<template>
  <div class="ui-container">
    <h2>Pagination</h2>
    <div class="ui-block inline">
      <Pagination :nbPages="10" />
      <Pagination :nbPages="7" />
      <Pagination :nbPages="3" />
    </div>
  </div>
</template>
